import { ModuleConfig } from '@schamburg-web/interfaces';
import { ImageMarker } from '@schamburg-web/lakecounty';
import { cameraIcon, cameraOutIcon } from '.';
import { getLocationDescription, getNormalizedIcon } from '../utils';

const CameraMarker: React.FC<{
  icon: any;
  module: ModuleConfig;
}> = ({ icon, module }) => {
  const normalizedIcon = getNormalizedIcon(icon);
  const iconSrc = normalizedIcon.alarmed ? cameraOutIcon : cameraIcon;
  
  return (
    <ImageMarker
      src={iconSrc}
      name={module.name}
      title={getLocationDescription(normalizedIcon)}
      showOutline={true}
    />
  );
};

export default CameraMarker;
